import { render } from "./OnboardingPage.vue?vue&type=template&id=a8ebdaa6&scoped=true"
import script from "./OnboardingPage.vue?vue&type=script&lang=js"
export * from "./OnboardingPage.vue?vue&type=script&lang=js"

import "./OnboardingPage.vue?vue&type=style&index=0&id=a8ebdaa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ebdaa6"]])

export default __exports__